import React from "react";
import PropTypes from "prop-types";

import { Form, Button, Row, Col } from "react-bootstrap";

export const FILTER_VERTICAL = "vertical";
export const FILTER_HORIZONTAL = "horizontal";
export const FILTER_WHITE = "white";
export const FILTER_BEIGE = "beige";

const Filter = ({
  children,
  onSubmited,
  onReseted,
  alignement,
  submitCols,
  resetCols,
  submitLabel,
  resetLabel,
  bgColor,
  withReset,
  withSubmit,
  withShadow,
  withBorder,
}) => {

  const getLg = () => {
    return alignement === FILTER_VERTICAL ? 2 : 1;

    /* if (alignement === FILTER_VERTICAL) {
            return ((with) ? 3 : 4)
        } else {
            return ((with) ? 1 : 2)
        } */
  };

  const getMd = () => {
    return alignement === FILTER_VERTICAL ? 3 : 1;

    /* if (alignement === FILTER_VERTICAL) {
            return ((with) ? 3 : 4)
        } else {
            return ((with) ? 1 : 3)
        } */
  };

  const getXs = () => {
    return alignement === FILTER_VERTICAL ? 4 : 2;

    /* if (alignement === FILTER_VERTICAL) {
            return ((with) ? 3 : 4)
        } else {
            return ((with) ? 2 : 6)
        } */
  };
 
  return (
    <div
      className={`filters filters-${bgColor}${
        withShadow ? " filters-shadow" : ""
      }${withBorder ? " filters-border" : ""}`}
    >
      <div className={`filters-${alignement}`}>
        <Form onSubmit={onSubmited}>
          <Row className="g-2">
            {children}

            {withReset ? (
              <Col lg={resetCols.lg} md={resetCols.md} sm={resetCols.sm}>
                <Button
                  type="button"
                  onClick={() => {
                    if (onReseted) onReseted();
                  }}
                >
                  <i className="bx bx-reset"></i>
                  {resetLabel !== "" ? (
                    <span id="reset-label">{resetLabel}</span>
                  ) : null}
                </Button>
              </Col>
            ) : null}

            {withSubmit ? (
              <Col lg={submitCols.lg} md={submitCols.md} sm={submitCols.sm}>
                <Button type="submit">
                  <i className="bx bx-search-alt"></i>
                  {submitLabel !== "" ? (
                    <span id="submit-label">{submitLabel}</span>
                  ) : null}
                </Button>
              </Col>
            ) : null}
          </Row>
        </Form>
      </div>
    </div>
  );
};
Filter.propTypes = {
  alignement: PropTypes.string,
  submitLabel: PropTypes.string,
  bgColor: PropTypes.string,
  children: PropTypes.node,
  onSubmited: PropTypes.func,
  withReset: PropTypes.bool,
  withSubmit: PropTypes.bool,
  withShadow: PropTypes.bool,
  withBorder: PropTypes.bool,
};
Filter.defaultProps = {
  alignement: FILTER_HORIZONTAL,
  bgColor: FILTER_WHITE,
  withShadow: false,
  withReset: false,
  withSubmit: false,
  withBorder: false,
  submitLabel: "",
  submitCols: { lg: 1, md: 2, sm: 3 },
  resetLabel: "",
  resetCols: { lg: 1, md: 2, sm: 3 },
};
export default Filter;